const actionTypes = {
  TOGGLE_SOUND: 'TOGGLE_SOUND',
  SET_SCREEN: 'SET_SCREEN',
  FETCH_GIST_REQUEST: 'FETCH_GIST_REQUEST',
  FETCH_GIST_SUCCESS: 'FETCH_GIST_SUCCESS',
  FINISH_BOOT: 'FINISH_BOOT',
  UPDATE_GAME: 'UPDATE_GAME',
  NEW_GAME: 'NEW_GAME',
  TOKEN_REQUEST: 'TOKEN_REQUEST',
  TOKEN_SUCCESS: 'TOKEN_SUCCESS',
  SET_NEXT_ACTION: 'SET_NEXT_ACTION',
  CLEAR_NEXT_ACTION: 'CLEAR_NEXT_ACTION',
  SAVE_GIST_REQUEST: 'SAVE_GIST_REQUEST',
  SAVE_GIST_SUCCESS: 'SAVE_GIST_SUCCESS',
  UPDATE_SFX: 'UPDATE_SFX',
  UPDATE_SPRITE: 'UPDATE_SPRITE',
  UPDATE_MAP: 'UPDATE_MAP',
  UPDATE_PHRASE: 'UPDATE_PHRASE',
  UPDATE_CHAIN: 'UPDATE_CHAIN',
  UPDATE_SONG: 'UPDATE_SONG',
  SET_TUTORIAL_SLIDE: 'SET_TUTORIAL_SLIDE',
  CLOSE_TUTORIAL: 'CLOSE_TUTORIAL',
  SHELVE_CASSETTE_REQUEST: 'SHELVE_CASSETTE_REQUEST',
  SHELVE_CASSETTE_SUCCESS: 'SHELVE_CASSETTE_SUCCESS',
  UNSHELVE_CASSETTE_REQUEST: 'UNSHELVE_CASSETTE_REQUEST',
  UNSHELVE_CASSETTE_SUCCESS: 'UNSHELVE_CASSETTE_SUCCESS',
  COUNTER_CASSETTE_REQUEST: 'COUNTER_CASSETTE_REQUEST',
  COUNTER_CASSETTE_SUCCESS: 'COUNTER_CASSETTE_SUCCESS',
  SET_SCROLL_INFO: 'SET_SCROLL_INFO',
  SET_CODE_TAB: 'SET_CODE_TAB'
}

export default actionTypes



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js